import API_URL from "@/constant/api.config";
import axios from "axios";
import axiosInstance from "@/axiosHttp";

export const filterProducts = async (reqData) => {
    let u = localStorage.getItem("user");
    if(u) {
        const response =  await axiosInstance.post(API_URL + "/filter-products", reqData);
        return response.data ? response.data : null;
    } else {
        const response = await axios.post(API_URL + "/filter-products", reqData, {
            headers: { Accept: "application/json" },
            timeout: 10000,
        });
        return response.data ? response.data : null;
    }
};

export const marketPlaceHomeData = async () => {
    let u = localStorage.getItem("user");
    if(u) {
        const response = await axiosInstance.get(API_URL + "/marketplace/home");
        return response.data ? response.data.data : [];
    } else {
        const response = await axios.get(API_URL + "/marketplace/home");
        return response.data ? response.data.data : [];
    }
    
}

export const productDetailBySlug = async (slug) => {
    let u = localStorage.getItem("user");
    if(u) {
        const response = await axiosInstance.get(API_URL + "/product-detail/" + slug);
        return response.data ? response.data.data : null;
    } else {
        const response = await axios.get(API_URL + "/product-detail/" + slug);
        return response.data ? response.data.data : null;
    }
    
} 

export const favProduct = async (reqData) => {
    const response = await axiosInstance.post(API_URL + "/favorite-product", reqData);
    return response.data ? response.data : null;
}